import React, { useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideOfflineIndicator } from '../../reducers/uiSlice';
import { cn } from '../../lib/utils';

const OfflineIndicator = memo(() => {
    const dispatch = useDispatch();
    const { showOfflineIndicator } = useSelector(state => state.ui.networkStatus);

    useEffect(() => {
        if (showOfflineIndicator) {
            const timer = setTimeout(() => {
                dispatch(hideOfflineIndicator());
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [showOfflineIndicator, dispatch]);

    return (
        <div
            className={cn(
                'fixed top-4 left-4 right-4 z-[9999] transition-all duration-300 ease-out',
                showOfflineIndicator
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 -translate-y-4 pointer-events-none'
            )}
        >
            <div className="bg-orange-400 text-white rounded-xl p-4 shadow-lg mx-auto max-w-sm">
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <p className="font-medium text-sm flex-1">
                        You are offline. You can continue the form filling.
                    </p>
                    <button
                        onClick={() => dispatch(hideOfflineIndicator())}
                        className="w-6 h-6 rounded-full hover:bg-white/10 flex items-center justify-center"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
});

OfflineIndicator.displayName = 'OfflineIndicator';

export default OfflineIndicator;